module.exports = __webpack_public_path__ + "static/media/idverification.5c80645e.png";